import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) { setError("Password minimal 6 karakter."); return; }
    if (form.password !== form.confirm) { setError("Konfirmasi password tidak cocok."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      toast.success("Password berhasil diperbarui.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="Masukkan token reset dan password baru Anda."
      footer={<>Kembali ke <Link to="/login" className="font-semibold text-brand hover:underline">halaman masuk</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        {error && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="reset-error">{error}</div>}
        <div>
          <Label htmlFor="token">Token Reset</Label>
          <Input id="token" required data-testid="reset-token"
            className="mt-1.5 h-11 font-mono text-sm" placeholder="Tempel token dari tautan reset"
            value={token} onChange={(e) => setToken(e.target.value)} />
        </div>
        <div>
          <Label htmlFor="password">Password Baru</Label>
          <Input id="password" type="password" required data-testid="reset-password"
            className="mt-1.5 h-11" placeholder="Minimal 6 karakter"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        <div>
          <Label htmlFor="confirm">Konfirmasi Password Baru</Label>
          <Input id="confirm" type="password" required data-testid="reset-confirm"
            className="mt-1.5 h-11" placeholder="Ulangi password"
            value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
        </div>
        <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full h-11 bg-brand hover:bg-brand-hover">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Simpan password baru"}
        </Button>
      </form>
    </AuthShell>
  );
}
